import Animated from "./Animated";
import Media from "./Media";
import Tour from "./Tour";
import Contact from "./Contact";
import "./App.scss";

const App = () => {

    return (
        <div className="app-container">
            <Animated />
            <Media />
            <Tour />
            <Contact />
        </div>
    );
};

export default App;